import React, { useMemo } from 'react'

import { useTheme } from 'next-themes'
import NextNProgress from 'nextjs-progressbar'

import { useIsTrialPeriod } from '@/hooks/billing/useIsTrialPeriod'
import { useBanner } from '@/hooks/common/useBanner'
import { useMounted } from '@/hooks/common/useMounted'
import { useIsOnboarding } from '@/hooks/onboarding/useIsOnboarding'

const RouteProgressBar: React.FC = () => {
  const { isTrialPeriod, trialExpired } = useIsTrialPeriod()
  const { resolvedTheme } = useTheme()
  const { data: banner } = useBanner()

  const { isOnboarding } = useIsOnboarding()

  const isMounted = useMounted()

  const color = useMemo(() => {
    if (
      !isOnboarding &&
      (isTrialPeriod || trialExpired || (banner && banner.show))
    )
      return 'white'
    // for some reason, the america theme is not working on the server side
    if (resolvedTheme === 'america' && isMounted) return '#ef4444' // red-500
    if (resolvedTheme === 'professional' && isMounted) return '#ffd230' // banana
    return '#ff66b3' // branding pink
  }, [banner, isMounted, isOnboarding, isTrialPeriod, resolvedTheme])

  return (
    <NextNProgress
      color={color}
      height={3}
      startPosition={0.1}
      showOnShallow={false}
      options={{ showSpinner: false }}
    />
  )
}

export default RouteProgressBar
